import { render, staticRenderFns } from "./addMaterial.vue?vue&type=template&id=7cf03876&scoped=true"
import script from "./addMaterial.vue?vue&type=script&lang=js"
export * from "./addMaterial.vue?vue&type=script&lang=js"
import style0 from "./addMaterial.vue?vue&type=style&index=0&id=7cf03876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf03876",
  null
  
)

export default component.exports